import Lottie from 'lottie-react';

import json from '../jsons/podium-hover-pinch.json';

const Podium = props => {
  return <Lottie loop={false} animationData={json} {...props} />;
};

export default Podium;
